<template>
    <div class="parallelFragment-div">
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">MicroSynteny</h2>
        </div>
        <div id="region_select">
            <div style="margin-right: 30px;margin-top: 8px; float: left">
                <a style="font-size: 20px; color: #407338; font-weight: bold">Base on</a>
            </div>
            <el-radio-group v-model="radio">
                <el-radio :label="1" border>Genes</el-radio>
                <el-radio :label="2" border>Fragments</el-radio>
            </el-radio-group>
        </div>

        <div v-if="select_gene" style="width: 1120px;margin: auto">
            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="200px">
                <el-form-item label="Gene 1">
                    <el-input style="width: 140px" v-model="gene1" placeholder="Gene 1"></el-input>
                </el-form-item>

                <el-form-item label="Gene 1 upstream (kb)">
                    <el-input style="width: 140px" v-model="gene1Upstream" placeholder="Gene 1 upstream" @keyup.native="number"></el-input>
                </el-form-item>

                <el-form-item label="Gene 1 dowmstream (kb)">
                    <el-input style="width: 140px" v-model="gene1Downstream" placeholder="Gene 1 dowmstream" @keyup.native="number"></el-input>
                </el-form-item>
            </el-form>

            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="200px">
                <el-form-item label="Gene 2">
                    <el-input style="width: 140px" v-model="gene2" placeholder="Gene 2"></el-input>
                </el-form-item>

                <el-form-item label="Gene 2 upstream (kb)">
                    <el-input style="width: 140px" v-model="gene2Upstream" placeholder="Gene 2 upstream" @keyup.native="number"></el-input>
                </el-form-item>

                <el-form-item label="Gene 2 dowmstream (kb)">
                    <el-input style="width: 140px" v-model="gene2Downstream" placeholder="Gene 2 dowmstream" @keyup.native="number"></el-input>
                </el-form-item>
            </el-form>

            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="200px">
                <el-form-item style="text-align: left" label="example">
                    <el-button type="primary" style="width: 300px;" @click="example456">AT4G38970 to Bra011884</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 80px;margin-left: 203px" @click="example_help">Help</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="isSyntenic" type="primary" style="width: 200px; margin-left: 187px" @click="returnSyntenicGene">BackToSyntenicGene</el-button>
                    <el-button v-else type="primary" style="width: 200px; margin-left: 187px" title="Please click this button when you jump from Syntenic Gene!" disabled>BackToSyntenicGene</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 120px; margin-left: 290px" @click="judgeStreamSize">SUBMIT</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div v-if="select_fragment" style="width: 1100px;margin: auto">
            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="120px">
                <el-form-item style="text-align: left" label="genome 1">
                    <el-select style="width: 180px;margin-right: 7px" v-model="genome1">
                        <template v-for="genome in genome_sheet">
                            <el-option v-if="genome.species != 'All'" :key="genome" :label="genome.species" :value="genome.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item style="text-align: left" label="chromosome 1">
                    <el-select style="width: 180px;margin-right: 7px" v-model="chromosome1">
                        <template v-for="chromosome in chromosome_sheet1">
                            <el-option :key="chromosome" :label="chromosome.Chr" :value="chromosome.Chr"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item label="start position 1">
                    <el-input style="width: 120px" v-model="startPos1" placeholder="start position1" @keyup.native="number"></el-input>
                </el-form-item>

                <el-form-item label="end position 1">
                    <el-input style="width: 120px" v-model="endPos1" placeholder="end position1" @keyup.native="number"></el-input>
                </el-form-item>
            </el-form>

            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="120px">
                <el-form-item style="text-align: left" label="genome 2">
                    <el-select style="width: 180px;margin-right: 7px" v-model="genome2">
                        <template v-for="genome in genome_sheet">
                            <el-option v-if="genome.species != 'All'" :key="genome" :label="genome.species" :value="genome.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item style="text-align: left" label="chromosome 2">
                    <el-select style="width: 180px;margin-right: 7px" v-model="chromosome2">
                        <template v-for="chromosome in chromosome_sheet2">
                            <el-option :key="chromosome" :label="chromosome.Chr" :value="chromosome.Chr"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item label="start position 2">
                    <el-input style="width: 120px" v-model="startPos2" placeholder="start position2" @keyup.native="number"></el-input>
                </el-form-item>

                <el-form-item label="end position 2">
                    <el-input style="width: 120px" v-model="endPos2" placeholder="end position2" @keyup.native="number"></el-input>
                </el-form-item>
            </el-form>

            <el-form :inline="true" size="small" @submit.native.prevent class="demo-form-inline" style="margin-top: 15px" label-width="120px">
                <el-form-item style="text-align: left" label="example">
                    <el-button type="primary" style="width: 550px; font-size: 12px" @click="example123">Ath_TAIR_V10.1 Chr4:18134000..18226000 to Brara_Chiifu_V1.5 A01:75000..130000</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 80px;margin-left: 480px" @click="example_help">Help</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="width: 120px; margin-left: 490px" @click="judgeRegionsize">SUBMIT</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="width:1100px; margin: 0 auto;">
            <a style="color: #407338;font-size:16px;">
                ● The horizontal rectangle represents the gene, which can be popped up by clicking.<br>
                ● The vertical rectangle represents the cds area of the gene.<br/>
                ● The <a style="color: red;"><b>red</b></a> indicates the gene you searched for.<br/>
                ● The <a style="color: #9b59b6;"><b>purple</b></a> means the genes direction is positive, 
                while <a style="color: #130F4A"><b>dark blue</b></a> means the gene direction is negative.<br/>
                ● Click "Back" button above to return to the "Syntenic Gene and Subgenome" page if you come from it.<br>
            </a>
        </div>
        <svg width="1100" height="200" style="margin:25px 49px;border: 1px solid #407338" id="mainsvg" class="svgs"></svg>
        <div id="waiting" v-if="isWaiting">
            <img src="../assets/img/waiting.gif" style="height: 200px;width: 200px">
        </div>
        <MicroSyntenyFunctionSeletion v-if="boxtarget" :target="selection_gene"
            @hideBox="hideSelectionBox"
            @watchSubFunction="common.searchSubFunction"></MicroSyntenyFunctionSeletion>
        <MicroSyntenyFunctionSeletionBra v-if="Bra_boxtarget" :target="selection_gene"
            @hideBox="hideBraSelectionBox"
            @watchSubFunction="common.searchSubFunction"></MicroSyntenyFunctionSeletionBra>                   
        <MicroSyntenyFunctionSeletionAth10 v-if="Ath10_boxtarget" :target="selection_gene"
            @hideBox="hideAth10SelectionBox"
            @watchSUbFunctionAth10="common.searchSubFunction"></MicroSyntenyFunctionSeletionAth10>
    </div>
</template>

<script>
    import * as d3 from 'd3';
    import axios from "axios";
    import MicroSyntenyFunctionSeletion from '../components/MicroSyntenyFunctionSeletion';
    import MicroSyntenyFunctionSeletionBra from '../components/MicroSyntenyFunctionSeletionBra';
    import MicroSyntenyFunctionSeletionAth10 from '../components/MicroSyntenyFunctionSeletionAth10';
    import {downloadable} from 'd3-downloadable';
    import {scrollAnimation} from '../assets/js/scrollPos';
    export default {
        name: "RegionMicroSynteny",
        data() {
            return {
                chromosome1: '',
                chromosome2: '',
                startPos1: '',
                startPos2: '',
                endPos1: '',
                endPos2: '',
                genome1: '',
                genome2: '',
                selection_gene: '',
                genome_sheet: {},
                chromosome_sheet1: {},
                chromosome_sheet2: {},
                isWaiting: 0,
                links: [],
                fragment_length: [],
                gene: [],
                cds: [],
                border: {},
                radio: 1,
                Aim: this.$route.query.Aim,
                boxtarget: 0,
                Bra_boxtarget: 0,
                Ath10_boxtarget: 0,
                gene1: this.$route.query.Gene1,
                gene2: this.$route.query.Gene2,
                gene1Upstream: 10,
                gene1Downstream: 10,
                gene2Upstream: 10,
                gene2Downstream: 10,
                select_fragment: 1,
                select_gene: 0,
                isSyntenic: 0,

                // links: [[{'start': 10791, 'end': 13040, 'pos': 1234}, {'start': 41899, 'end': 44158, 'pos': 4321}],
                //     [{'start': 1, 'end': 2755, 'pos': 2345}, {'start': 9923, 'end': 12669, 'pos': 5432}],
                //     [{'start': 41748, 'end': 44159, 'pos': 3456}, {'start': 46714, 'end': 49154, 'pos': 6543}],
                //     [{'start': 46477, 'end': 49029, 'pos': 4567}, {'start': 50001, 'end': 52515, 'pos': 7654}],
                //     [{'start': 10791, 'end': 12703, 'pos': 5678}, {'start': 10969, 'end': 12877, 'pos': 8765}],
                // ],
                // fragment_length: [{'name': 'Brapa30_A01_100000_150000', 'value':50000},
                //     {'name':'Brapa15_A01_75000_130000', 'value':55000},
                // ],
                // gene: [
                //     [
                //         {'gene_id': 'BraA01g000190.3C', 'start_pos': '101158', 'end_pos': '104774', 'parent': 'Brapa30_A01_100000_150000', 'strand': '-'},
                //         {'gene_id': 'BraA01g000200.3C', 'start_pos': '106156', 'end_pos': '108198', 'parent': 'Brapa30_A01_100000_150000', 'strand': '+'},
                //         {'gene_id': 'BraA01g000210.3C', 'start_pos': '109186', 'end_pos': '109996', 'parent': 'Brapa30_A01_100000_150000', 'strand': '+'},
                //         {'gene_id': 'BraA01g000220.3C', 'start_pos': '112309', 'end_pos': '114630', 'parent': 'Brapa30_A01_100000_150000', 'strand': '-'},],
                //     [
                //         {'gene_id': 'Bra011886', 'start_pos': '76738', 'end_pos': '77698', 'parent': 'Brapa15_A01_75000_130000', 'strand': '-'},
                //         {'gene_id': 'Bra011885', 'start_pos': '78912', 'end_pos': '82518', 'parent': 'Brapa15_A01_75000_130000', 'strand': '-'},
                //         {'gene_id': 'Bra011884', 'start_pos': '83900', 'end_pos': '85942', 'parent': 'Brapa15_A01_75000_130000', 'strand': '+'},
                //         {'gene_id': 'Bra011883', 'start_pos': '86930', 'end_pos': '89159', 'parent': 'Brapa15_A01_75000_130000', 'strand': '+'},]
                // ],
                // cds: [
                //     [
                //         {'gene_id': 'BraA01g000190.3C', 'start_pos': '104594', 'end_pos': '104774', 'parent': 'Brapa30_A01_100000_150000', 'strand': '-'}, 
                //         {'gene_id': 'BraA01g000190.3C', 'start_pos': '104222', 'end_pos': '104311', 'parent': 'Brapa30_A01_100000_150000', 'strand': '-'},
                //         {'gene_id': 'BraA01g000190.3C', 'start_pos': '104311', 'end_pos': '104138', 'parent': 'Brapa30_A01_100000_150000', 'strand': '-'}], 
                //     [
                //         {'gene_id': 'Bra011886', 'start_pos': '77627', 'end_pos': '77698', 'parent': 'Brapa15_A01_75000_130000', 'strand': '-'},
                //         {'gene_id': 'Bra011886', 'start_pos': '76738', 'end_pos': '77529', 'parent': 'Brapa15_A01_75000_130000', 'strand': '-'}],
                // ],
                // border: {'Brapa30_A01_100000_150000': '100000', 'Brapa15_A01_75000_130000': '75000'}
            }
        },
        mounted() {
            this.judgeStyle();
            this.get_genomes_show();
            this.judgeRegionType();
            this.judgeVuexStorage();
            this.judge_syntenic();
            // this.barChartInit();
            // this.judgeGeneSearch()
        },
        components: {
            MicroSyntenyFunctionSeletion,
            MicroSyntenyFunctionSeletionBra,
            MicroSyntenyFunctionSeletionAth10
        },
        methods: {
            judgeStyle() {
                document.getElementsByTagName('html')[0].style.height = '';
                document.getElementsByTagName('body')[0].style.height = '';
            },
            get_genomes_show() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-species-information/',
                    type: 'json',
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data);
                    this.genome_sheet = res.data
                })
            },
            judgeVuexStorage() {
                // console.log(this.$store.state)
                if (typeof this.Aim !== 'undefined') {
                    if (this.Aim == 'return') {
                        this.links = this.$store.state.links;
                        this.fragment_length = this.$store.state.fragment_length;
                        this.gene = this.$store.state.gene;
                        this.cds = this.$store.state.cds;
                        this.border = this.$store.state.border;
                        this.gene1 = this.$store.state.gene1;
                        this.gene2 = this.$store.state.gene2;
                        this.barChartInit();
                    }
                } else if (this.$store.state.gene.length != '0') {
                    // console.log(this.gene1)
                    // console.log(this.$store.state.gene1)
                    if (this.gene1 == this.$store.state.gene1 && this.gene2 == this.$store.state.gene2) {
                        this.links = this.$store.state.links;
                        this.fragment_length = this.$store.state.fragment_length;
                        this.gene = this.$store.state.gene;
                        this.cds = this.$store.state.cds;
                        this.border = this.$store.state.border;
                        this.barChartInit();
                    } else {
                        this.judgeGeneSearch()
                    }
                    // console.log(this.$store.state.checkList)
                    // console.log('OKOKOOK1')
                } else {
                    this.judgeGeneSearch()
                }
                // console.log("OKOKOOK4")
            },
            judgeRegionType() {
                if(this.radio == 1) {
                    this.select_gene = 1;
                    this.select_fragment = 0;
                } else {
                    this.select_gene = 0;
                    this.select_fragment = 1;
                }
            },
            judgeGeneSearch() {
                if(this.gene1.length != 0 && this.gene2.length != 0) {
                    this.searchStreamMicroSynteny();
                }
            },
            example123() {
                this.genome1 = 'Ath_TAIR_V10.1';
                this.chromosome1 = 'Chr4';
                this.startPos1 = '18134000';
                this.endPos1 = '18226000';
                this.genome2 = 'Brara_Chiifu_V1.5';
                this.chromosome2 = 'A01';
                this.startPos2 = '75000';
                this.endPos2 = '130000';
                this.searchRegionMicroSynteny();
            },
            example456() {
                this.gene1 = 'AT4G38970';
                this.gene2 = 'Bra011884';
                this.gene1Upstream = 10;
                this.gene2Upstream = 10;
                this.gene1Downstream = 10;
                this.gene2Downstream = 10;
                this.searchStreamMicroSynteny();
            },
            example_help() {
                this.$router.push({path: '../Userguide/'})
            },
            judgeRegionsize() {
                if (parseInt(this.endPos1) - parseInt(this.startPos1) <= 0) {
                    alert('End position must be greater than start position.');
                } else if (parseInt(this.endPos1) - parseInt(this.startPos1) >= 300000) {
                    alert('The maximum length allowed is 300kb.For more needs, please contact the website operation and maintenance personnel')
                } else if (parseInt(this.endPos2) - parseInt(this.startPos2) <= 0) {
                    alert('End position must be greater than start position.');
                } else if (parseInt(this.endPos2) - parseInt(this.startPos2) >= 300000) {
                    alert('The maximum length allowed is 300kb.For more needs, please contact the website operation and maintenance personnel')
                } else if (this.genome1 == '' || this.genome2 === '') {
                    alert('Please select genome.')
                } else if (this.chromosome1 === '' || this.chromosome2 === '') {
                    alert('Please select chromosome.')
                } else if (this.startPos1 === '' || this.startPos2 === '') {
                    alert('Please input start positions.')
                } else if (this.endPos1 === '' || this.endPos2 === '') {
                    alert('Please input end positions.')
                } else {
                    this.searchRegionMicroSynteny();
                }
            },
            judgeStreamSize() {
                if (parseInt(this.gene1Upstream) > 1000) {
                    alert("The maximum Upstream size is 1000kb!");
                } else if (parseInt(this.gene1Downstream) > 1000) {
                    alert("The maximum Downstream size is 1000kb!");
                } else if (parseInt(this.gene2Upstream) > 1000) {
                    alert("The maximum Upstream size is 1000kb!");
                } else if (parseInt(this.gene2Downstream) > 1000) {
                    alert("The maximum Downstream size is 1000kb!");
                } else if (typeof this.gene1 === 'undefined') {
                    alert("Please input Gene1!")
                } else if (typeof this.gene2 === 'undefined') {
                    alert("Please input Gene2!")
                } else {
                    this.searchStreamMicroSynteny()
                }
            },
            number() {
                this.startPos1=this.startPos1.replace(/[^.\d]/g,'');
                this.startPos1=this.startPos1.replace('.','');
                this.startPos2=this.startPos2.replace(/[^.\d]/g,'');
                this.startPos2=this.startPos2.replace('.','');
                this.endPos1=this.endPos1.replace(/[^.\d]/g,'');
                this.endPos1=this.endPos1.replace('.','');
                this.endPos2=this.endPos2.replace(/[^.\d]/g,'');
                this.endPos2=this.endPos2.replace('.','');
                this.gene1Upstream=this.gene1Upstream.replace(/[^.\d]/g,'');
                this.gene1Upstream=this.gene1Upstream.replace('.','');
                this.gene1Downstream=this.gene1Downstream.replace(/[^.\d]/g,'');
                this.gene1Downstream=this.gene1Downstream.replace('.','');
                this.gene2Upstream=this.gene2Upstream.replace(/[^.\d]/g,'');
                this.gene2Upstream=this.gene2Upstream.replace('.','');
                this.gene2Downstream=this.gene2Downstream.replace(/[^.\d]/g,'');
                this.gene2Downstream=this.gene2Downstream.replace('.','');
            },
            searchRegionMicroSynteny() {
                d3.select('svg').selectAll('*').remove();
                this.isWaiting = 1;
                const genome1 = this.genome1;
                const genome2 = this.genome2;
                const chromosome1 = this.chromosome1;
                const chromosome2 = this.chromosome2;
                const startPos1 = this.startPos1;
                const startPos2 = this.startPos2;
                const endPos1 = this.endPos1;
                const endPos2 = this.endPos2;
                axios({
                    url: 'http://39.100.233.196:8001/api/search-region-microsynteny/',
                    type: 'json',
                    params: {
                        genome1,
                        chromosome1,
                        startPos1,
                        endPos1,
                        genome2,
                        chromosome2,
                        startPos2,
                        endPos2,
                    }
                }).then((res) => {
                    // console.log(res.data)
                    this.links = res.data[0];
                    this.fragment_length = res.data[1];
                    this.gene = res.data[2];
                    this.cds = res.data[3];
                    this.border = res.data[4];
                    // console.log(res.data);
                    this.barChartInit();
                    this.isWaiting = 0;

                    this.$store.commit('editLinks', this.links);
                    this.$store.commit('editFragmentLength', this.fragment_length);
                    this.$store.commit('editGene', this.gene);
                    this.$store.commit('editCds', this.cds);
                    this.$store.commit('editBorder', this.border);
                    this.$store.commit('editGene1', this.gene1);
                    this.$store.commit('editGene2', this.gene2);

                    const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    scrollAnimation(currentY, 500)
                })
            },
            searchStreamMicroSynteny() {
                d3.select('svg').selectAll('*').remove();
                this.isWaiting = 1;
                const gene1 = this.gene1;
                const gene2 = this.gene2;
                const gene1Upstream = this.gene1Upstream;
                const gene2Upstream = this.gene2Upstream;
                const gene1Downstream = this.gene1Downstream;
                const gene2Downstream = this.gene2Downstream;
                axios({
                    url: 'http://39.100.233.196:8001/api/search-stream-microsynteny/',
                    type: 'json',
                    timeout: 90000,
                    params: {
                        gene1,
                        gene1Upstream,
                        gene1Downstream,
                        gene2,
                        gene2Upstream,
                        gene2Downstream,
                    }
                }).catch(err => {                                    // eslint-disable-line no-unused-vars
                    // console.log(err)
                    alert("Please input correct information or chech your network");
                    // setTimeout(location.reload(), 1000)
                    this.isWaiting = 0;
                }).then((res) => {
                    console.log(res.data)
                    this.links = res.data[0];
                    this.fragment_length = res.data[1];
                    // console.log(res.data[1])
                    this.gene = res.data[2];
                    this.cds = res.data[3];
                    this.border = res.data[4];
                    // console.log(res.data);
                    this.barChartInit();
                    this.isWaiting = 0;

                    this.$store.commit('editLinks', this.links);
                    this.$store.commit('editFragmentLength', this.fragment_length);
                    this.$store.commit('editGene', this.gene);
                    this.$store.commit('editCds', this.cds);
                    this.$store.commit('editBorder', this.border);
                    this.$store.commit('editGene1', this.gene1);
                    this.$store.commit('editGene2', this.gene2);

                    const currentY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    scrollAnimation(currentY, 500)
                })
            },
            judge_syntenic() {
                // console.log(this.$store.state.checkList);
                if (this.$store.state.checkList) {
                    this.isSyntenic = 1;
                } else {
                    this.isSyntenic = 0;
                }
                // console.log(this.isSyntenic);
            },
            returnSyntenicGene() {
                if (this.$store.state.checkList) {
                    this.$router.push({path: "../syntenic-gene/", query: {Aim: 'return'}})
                } else {
                    alert('Error! Please click this button when you jump from Syntenic Gene!')
                }
            },
            toSearchMSA(seq0, seq1) {
                let routeUrl = this.$router.resolve({
                    path: "../MSA1/",
                    query: {Seq0: seq0, Seq1: seq1}
                });
                window.open(routeUrl.href, '_blank')
            },
            // searchSubFunction(subfunction, geneID){
            //     // console.log(subfunction)
            //     // console.log(geneID)
            //     if (subfunction == 'JBrowse') {
            //         axios({
            //             url: 'http://39.100.233.196:8001/api/search-JBrowse-gene/',
            //             type: 'json',
            //             params: {
            //                 geneID
            //             },
            //             method: 'get',
            //         }).then((res)=>{
            //             // console.log(res.data[0])
            //             var species = res.data[0].species
            //             var chromosome = res.data[0].chromosome
            //             var startPos = (res.data[0].startPos - 300).toString()
            //             var endPos = (res.data[0].endPos + 300).toString()
            //             // this.$router.push({path: "../SearchJBrowse/", query:{Genome: species, Chromosome:chromosome, StartPos:startPos, EndPos: endPos}});
            //             let routeUrl = this.$router.resolve({
            //                 path: "../SearchJBrowse/",
            //                 query:{Genome: species,
            //                     Chromosome:chromosome,
            //                     StartPos:startPos,
            //                     EndPos: endPos}
            //             });
            //             window.open(routeUrl.href, '_blank');
            //         })
            //         // 通过../来传参给父视图，然后再刷新到JBrowse去，很强
            //     }
            //     else if (subfunction == 'Gene sequence') {
            //         // console.log(geneID)
            //         this.searchGeneSeq(geneID)
            //     }
            //     else if (subfunction == 'Syntenic gene') {
            //         // let routeUrl = this.$router.resolve({
            //         //     path: "../syntenic-gene/",
            //         //     query: {Gene: geneID}
            //         // });
            //         // window.open(routeUrl.href, '_blank');
            //         this.$router.push({path: "../syntenic-gene/", query: {Gene: geneID, Aim: 'search'}})
            //     }
            //     else if (subfunction == 'Flanking region') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../FlankingRegion/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank');
            //     }
            //     else if (subfunction == 'Annotations') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../Annotations/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank');
            //     }
            //     else if (subfunction == 'Nonsyntenic orth') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../NonSyntenicOrthologs/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank')
            //     }
            //     else if (subfunction == 'Flanking Primer') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../PrimerDesign/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank')
            //     }
            //     else if (subfunction == 'Polymorph') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../Polymorph/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank')
            //     }
            //     else if (subfunction == 'BrapaLeafeFP') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../BrapaLeafeFP/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank')
            //     }
            //     else if (subfunction == 'Coge') {
            //         window.open('https://genomevolution.org/CoGe/FeatView.pl?accn=' + geneID, '_blank');
            //     }
            //     else if (subfunction == 'TAIR') {
            //         window.open('https://www.arabidopsis.org/servlets/TairObject?name=' + geneID + '&type=locus');
            //     }
            //     else if (subfunction == 'Expression in At eFP') {
            //         window.open('http://bar.utoronto.ca/efp/cgi-bin/efpWeb.cgi?primaryGene=' + geneID)
            //     }
            //     else if (subfunction == 'AlphaFold') {
            //         window.open('https://alphafold.ebi.ac.uk/search/text/' + geneID)
            //     }
            //     else if (subfunction == 'Transcriptome') {
            //         let routeUrl = this.$router.resolve({
            //             path: "../Transcriptome/",
            //             query: {Gene: geneID}
            //         });
            //         window.open(routeUrl.href, '_blank')
            //     }
            // },
            hideSelectionBox () {
                this.boxtarget = 0;
            },
            hideBraSelectionBox () {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath10_boxtarget = 0;
            },
            searchGeneSeq (geneID) {
                // console.log(geneID)
                let routeUrl = this.$router.resolve({
                    path: "../GeneSequence/",
                    query: {Gene: geneID}
                });
                window.open(routeUrl.href, '_blank');
            },
            barChartInit() {
                let _this = this;
                const svg = d3.select('#mainsvg');
                const width = +svg.attr('width');
                const height = +svg.attr('height');
                const margin = {top: 30, right: 30, bottom: 30, left: 200};
                const innerWidth = width - margin.left - margin.right;
                const innerHeight = height - margin.top - margin.bottom;

                const xScale = d3.scaleLinear()
                .domain([0, d3.max(this.fragment_length, d => d.value)])
                // .domain([1000000, 3000000])
                .range([0, innerWidth]);

                // 用回调函数的形式来将fragment_length中的name属性来赋值给yScale，可以使用这个来绘制我们的染色体
                const yScale = d3.scaleBand()
                .domain(this.fragment_length.map(d => d.name))
                .range([0, innerHeight])
                .paddingInner(0.6);

                // 渲染需要一个容器，而这个就可以提供一个容器，.attr('id', 'maingroup')是给这个容器提供一个id选择器，
                // 这个也相当于是一块SVG的画布，之后的所有操作都在这块画布上进行，可以进行坐标轴渲染，柱状图的柱子的渲染等等。
                const g = svg.append('g').attr('id', 'maingroup')
                .attr('transform', `translate(${margin.left}, ${margin.top})`);

                // const xAxis = d3.axisBottom(xScale);
                // 这个坐标系统是默认将（0,0）放置在左上角的，因此需要将横坐标进行一个移动，把它移动到画布的底端
                // const xGroop = g.append('g').call(xAxis).attr('transform', `translate(${0}, ${innerHeight})`);

                // 利用axisLeft来给坐标轴一个定义，从而来构建坐标轴，但是目前并未对坐标轴进行任何形式的渲染，
                // 仅仅是对坐标轴的一个定义，这个这个axisLeft其实就是一个函数，对yScale来进行一个赋值，这是一种函数式编程
                const yAxis = d3.axisLeft(yScale);
                // call 命令是调用call()中的内容来填上g中的路径
                g.append('g').call(yAxis);

                // 用这个forEach对data的每一个数据进行一个渲染
                // this.fragment_length.forEach(d => {
                //     g.append('rect')
                //     .attr('width', xScale(d.value))
                    // 可以使用hetght来控制这个矩形的高度，对我们实现共线性展示也有很大帮助
                    // .attr('height', yScale.bandwidth())
                    // .attr('fill', '#3498db')
                    // .attr('opacity', 0.5)
                    // 用yScale（d.name来映射这个矩形应该在的纵坐标位置），如果需要的话可以使用xScale来将其居中显示，这样有利于我们进行共线性的展示
                    // .attr('y', yScale(d.name))
                    // .attr('x', (innerWidth - xScale(d.value)) / 2)
                    // .call(d3.drag()
                    // .subject(function() {
                    //     const t = d3.select(this);
                    //     return {x:t.attr("x"),y:t.attr("y")}
                    // })
                    // .on('drag', function() {
                    //     d3.select(this)
                    //     .attr('x', d3.event.x)})
                    // );
                // });

                const bandwidth = innerHeight / (2 - 0.6) * (1 - 0.6);
                const step = innerHeight / (2 - 0.6);

                const areaPath1 = d3.area()
                .y0(bandwidth)
                .y1(step)
                .x0(d => xScale(d.start) + (innerWidth - xScale(this.fragment_length[0].value)) / 2)
                // .x0(d => xScale(d.start))
                .x1(d => xScale(d.end) + (innerWidth - xScale(this.fragment_length[1].value)) / 2);

                // this.links.forEach(d => {
                //     g.append('path')
                //     .attr('id', 'links')
                //     .attr('d', areaPath1(d.slice(0, 2)))
                //     .attr('stroke', null)
                //     .attr('fill', '#999999')
                //     .attr('opacity', 0.3)
                //     .on('mouseover', function() {
                //         d3.select(this)
                //         .attr('fill', '#eb4d4b')
                //         .attr('opacity', 0.8)
                //         .append('title')
                //         .text(d[d.length - 1][0] + "→" + d[d.length - 1][1])
                //     })
                //     .on('mouseout', function() {
                //         d3.select(this)
                //         .attr('fill', '#999999')
                //         .attr('opacity', 0.3)
                //     })
                // });

                g.append('clipPath')
                .attr('id', 'clip')
                .append('rect')
                .attr('width', innerWidth)
                .attr('height', innerHeight);

                let updateFragment = g.append('g')
                .attr('class', 'chart_fragment')
                .selectAll('path.fragment')
                .data(this.fragment_length)
                .enter()
                .append('rect')
                .attr('clip-path', 'url(#clip)')
                .attr('class', 'fragment')
                .attr('width', d => xScale(d.value))
                .attr('height', yScale.bandwidth())
                .attr('fill', '#99CCFF')
                .attr('opacity', 0.5)
                .attr('y', d => yScale(d.name))
                .attr('x', d => (innerWidth - xScale(d.value)) / 2)

                let updateLinks = g.append('g')
                .attr('class', 'chart_links')
                .selectAll('path.links')
                .data(this.links)
                .enter()
                .append('path')
                .attr('clip-path', 'url(#clip)')
                .attr('d', areaPath1)
                .attr('fill', '#999999')
                .attr('opacity', 0.3)
                .attr('stroke', null)
                .on('mouseover', function(d) {
                    d3.select(this)
                    .attr('fill', '#eb4d4b')
                    .attr('opacity', 0.8)
                    .append('title')
                    .text(d[0].pos + "→" + d[1].pos)
                })
                .on('mouseout', function() {
                    d3.select(this)
                    .attr('fill', '#999999')
                    .attr('opacity', 0.3)
                })
                .on('click', function(d) {
                    var seq0 = d[0].pos;
                    var seq1 = d[1].pos;
                    // console.log(seq0, seq1);
                    _this.toSearchMSA(seq0, seq1);
                });

                let updateCDS0 = g.append('g')
                .attr('class', 'chart_cds_0')
                .selectAll('path.cds_0')
                .data(this.cds[0])
                .enter()
                .append('rect')
                .attr('clip-path', 'url(#clip)')
                .attr('class', 'cds_0')
                .attr('width', d => xScale(Math.abs(d.start_pos - d.end_pos)))
                .attr('height', 0.6 * yScale.bandwidth())
                // .attr('fill', d => d.strand == '+' ? '#9b59b6' : '#130f4a')
                .attr('fill', function(d) {
                    if (d.gene_id == _this.gene1) {
                        return 'red'
                    } else if (d.strand == '+') {
                        return '#9b59b6'
                    } else {
                        return '#130f4a'
                    }
                })
                .attr('y', d => yScale(d.parent) + 0.2 * bandwidth)
                .attr('x', d => xScale(d.start_pos - this.border[d.parent]) + (innerWidth  - xScale(this.fragment_length[0].value)) / 2)

                let updateCDS1 = g.append('g')
                .attr('class', 'chart_cds_1')
                .selectAll('path.cds_1')
                .data(this.cds[1])
                .enter()
                .append('rect')
                .attr('clip-path', 'url(#clip)')
                .attr('class', 'cds_1')
                .attr('width', d => xScale(Math.abs(d.start_pos - d.end_pos)))
                .attr('height', 0.6 * yScale.bandwidth())
                // .attr('fill', d => d.strand == '+' ? '#9b59b6' : '#130f4a')
                .attr('fill', function(d) {
                    if (d.gene_id == _this.gene2) {
                        return 'red'
                    } else if (d.strand == '+') {
                        return '#9b59b6'
                    } else {
                        return '#130f4a'
                    }
                })
                .attr('y', d => yScale(d.parent) + 0.2 * bandwidth)
                .attr('x', d => xScale(d.start_pos - this.border[d.parent]) + (innerWidth  - xScale(this.fragment_length[1].value)) / 2)

                let updateGene0 = g.append('g')
                .attr('class', 'chart_gene_0')
                .selectAll('path.gene_0')
                .data(this.gene[0])
                .enter()
                .append('rect')
                .attr('clip-path', 'url(#clip)')
                .attr('class', 'gene_0')
                .attr('width', d => xScale(Math.abs(d.start_pos - d.end_pos)))
                .attr('height', 0.2 * yScale.bandwidth())
                // .attr('fill', d => d.strand == '+' ? '#9b59b6' : '#130f4a')
                .attr('fill', function(d) {
                    if (d.gene_id == _this.gene1) {
                        return 'red'
                    } else if (d.strand == '+') {
                        return '#9b59b6'
                    } else {
                        return '#130f4a'
                    }
                })
                .attr('y', d => yScale(d.parent) + 0.4 * bandwidth)
                .attr('x', d => xScale(d.start_pos - this.border[d.parent]) + (innerWidth - xScale(this.fragment_length[0].value)) / 2)
                .on('mouseover', function(d) {
                    d3.select(this)
                    .append('title')
                    .text(d.gene_id)
                })
                .on('click', function(d) {
                    _this.selection_gene = d.gene_id;
                    if (d.gene_id.substr(0, 2) == 'AT') {
                        _this.Ath10_boxtarget = 1;
                        _this.Bra_boxtarget = 0;
                        _this.boxtarget = 0;
                    } else if (d.gene_id.substr(0, 3) == "Bra") {
                        _this.Ath10_boxtarget = 0;
                        _this.Bra_boxtarget = 1;
                        _this.boxtarget = 0;
                    } else {
                        _this.Ath10_boxtarget = 0;
                        _this.Bra_boxtarget = 0;
                        _this.boxtarget = 1;
                    }
                    // console.log("OKOKOOK")
                });

                let updateGene1 = g.append('g')
                .attr('class', 'chart_gene_1')
                .selectAll('path.gene_1')
                .data(this.gene[1])
                .enter()
                .append('rect')
                .attr('clip-path', 'url(#clip)')
                .attr('class', 'gene_1')
                .attr('width', d => xScale(Math.abs(d.start_pos - d.end_pos)))
                .attr('height', 0.2 * yScale.bandwidth())
                // .attr('fill', d => d.strand == '+' ? '#9b59b6' : '#130f4a')
                .attr('fill', function(d) {
                    if (d.gene_id == _this.gene2) {
                        return 'red'
                    } else if (d.strand == '+') {
                        return '#9b59b6'
                    } else {
                        return '#130f4a'
                    }
                })
                .attr('y', d => yScale(d.parent) + 0.4 * bandwidth)
                .attr('x', d => xScale(d.start_pos - this.border[d.parent]) + (innerWidth - xScale(this.fragment_length[1].value)) / 2)
                .on('mouseover', function(d) {
                    d3.select(this)
                    .append('title')
                    .text(d.gene_id)
                })
                .on('click', function(d) {
                    _this.selection_gene = d.gene_id;
                    if (d.gene_id.substr(0, 2) == 'AT') {
                        _this.Ath10_boxtarget = 1;
                        _this.Bra_boxtarget = 0;
                        _this.boxtarget = 0;
                    } else if (d.gene_id.substr(0, 3) == "Bra") {
                        _this.Ath10_boxtarget = 0;
                        _this.Bra_boxtarget = 1;
                        _this.boxtarget = 0;
                    } else {
                        _this.Ath10_boxtarget = 0;
                        _this.Bra_boxtarget = 0;
                        _this.boxtarget = 1;
                    }
                });
                
                let zoom = d3.zoom()
                .scaleExtent([0.5, 10])
                .translateExtent([
                    [0, 0],
                    [innerWidth, innerHeight]
                ])
                .extent([
                    [0, 0],
                    [innerWidth, innerHeight]
                ])
                .on('zoom', zoomed)

                svg.call(zoom)

                function zoomed() {
                    let t = d3.event.transform;

                    let area = areaPath1
                    .x0(d => t.applyX(xScale(d.start)) + t.applyX((innerWidth - xScale(_this.fragment_length[0].value)) / 2))
                    .x1(d => t.applyX(xScale(d.end)) + t.applyX((innerWidth - xScale(_this.fragment_length[1].value)) / 2));

                    updateLinks.attr('d', area);

                    updateFragment
                    .attr('width', d => t.applyX(xScale(d.value)) - t.x)
                    .attr('x', d => t.applyX(((innerWidth - xScale(d.value)) / 2)) + t.x);

                    updateCDS0
                    .attr('width', d => t.applyX(xScale(Math.abs(d.start_pos - d.end_pos))) - t.x)
                    .attr('x', d => t.applyX(xScale(d.start_pos - _this.border[d.parent])) + t.applyX((innerWidth - xScale(_this.fragment_length[0].value)) / 2));

                    updateCDS1
                    .attr('width', d => t.applyX(xScale(Math.abs(d.start_pos - d.end_pos))) - t.x)
                    .attr('x', d => t.applyX(xScale(d.start_pos - _this.border[d.parent])) + t.applyX((innerWidth - xScale(_this.fragment_length[1].value)) / 2));

                    updateGene0
                    .attr('width', d => t.applyX(xScale(Math.abs(d.start_pos - d.end_pos))) - t.x)
                    .attr('x', d => t.applyX(xScale(d.start_pos - _this.border[d.parent])) + t.applyX((innerWidth - xScale(_this.fragment_length[0].value)) / 2));

                    updateGene1
                    .attr('width', d => t.applyX(xScale(Math.abs(d.start_pos - d.end_pos))) - t.x)
                    .attr('x', d => t.applyX(xScale(d.start_pos - _this.border[d.parent])) + t.applyX((innerWidth - xScale(_this.fragment_length[1].value)) / 2));
                }

                d3.selectAll('.tick text').attr('font-size', '1em');
                // g.append('text').text('Genomic Region MicroSynteny')
                // .attr('font-size', '2em')
                // .attr('transform', `translate(${innerWidth/2}, -20)`)
                // text-anchor可以调整text的移动的位置，比如下面的middle，可以设置将其参考位置设置为中间
                // .attr('text-anchor', 'middle');

                svg.call(downloadable({
                    width: width,
                    height: height,
                    filename: 'parallel'
                }))
            },
        },
        watch: {
            'genome1': {
                handler: function (val) {
                    if (val.length != 0) {
                        const search_genome = this.genome1;
                        axios({
                            url: 'http://39.100.233.196:8001/api/get-chromosome/',
                            type: 'json',
                            timeout: 30000,
                            params: {
                                search_genome
                            }
                        }).then((res)=>{
                            // console.log(res.data);
                            this.chromosome_sheet1 = res.data
                        })
                    }
                },
            },
            'genome2': {
                handler: function (val) {
                    if (val.length != 0) {
                        const search_genome = this.genome2;
                        axios({
                            url: 'http://39.100.233.196:8001/api/get-chromosome/',
                            type: 'json',
                            timeout: 30000,
                            params: {
                                search_genome
                            }
                        }).then((res)=>{
                            // console.log(res.data);
                            this.chromosome_sheet2 = res.data
                        })
                    }
                },
            },
            'radio': {
                handler() {
                    this.judgeRegionType();
                }
            }
        }
    }
</script>

<style>
    #mainpath {
        fill: none;
        stroke: #407338;
        stroke-width: 3px;
    }

    .parallelFragment-div {
        overflow:auto;
        background: #E8F2EC;
        width: 1200px;
        margin: 0 auto;
    }

    .parallelFragment-div  .el-form-item__label {
        color: #407338;
    }

    .parallelFragment-div .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .parallelFragment-div .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    .parallelFragment-div .el-form-item__content{
        width: 120px;
    }

    .parallelFragment-div .el-input{
        width: 120px;
    }

    #waiting {
        text-align: center;
        position: fixed;
        width: 200px;
        height: 200px;
        left: 0;
        right: 0;
        top: 35%;
        margin: 0 auto;
    }

    .parallelFragment-div .el-select-dropdown__item {
        color: #407338;
    }

    .parallelFragment-div .el-input__inner {
        color: #407338;
    }

    #region_select {
        margin: 20px auto 20px 400px;
        /* border: 1px solid #000; */
    }

    #region_select .el-radio__input.is-checked .el-radio__inner {
        border-color: #407338;
        background: #407338;
    }

    #region_select .el-radio.is-bordered.is-checked {
        border-color: #407338;
    }

    #region_select .el-radio__input.is-checked + .el-radio__label {
        color: #407338;
    }

    #region_select .el-radio.is-bordered {
        border: 2px solid #95a5a6;
    }

    #region_select .el-radio {
        font-weight: 800;
    }

    
</style>